import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalChiTietHopDongNV } from "./ModalChiTietHopDong";
// import { ModalGiaHan } from "./ModalGiaHan";

export const BtnChiTietHopDongNhanVay = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      {typeof item.MaNhanVay !== "undefined" && (
        <a href={() => false} className="color-xanh-bold" onClick={handleShow}>
          {item.MaNhanVay}
        </a>
      )}
      {typeof item.MaNhanVay === "undefined" && (
        <a href={() => false} className="color-xanh-bold" onClick={handleShow}>
          {item.Code}
        </a>
      )}
      {show && typeof item.ID !== "undefined" && (
        <ModalChiTietHopDongNV
          show={show}
          onHide={handleClose}
          nhanvayId={item.ID}
          item={item}
        />
      )}
      {show && typeof item.NhanVayId !== "undefined" && (
        <ModalChiTietHopDongNV
          show={show}
          onHide={handleClose}
          nhanvayId={item.NhanVayId}
          item={item}
        />
      )}
    </>
  );
};
